// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAYchXFOuXKRD-fZ9ycJaow6I_DkQAFBMk",
  authDomain: "rosyhealth-7f261.firebaseapp.com",
  projectId: "rosyhealth-7f261",
  storageBucket: "rosyhealth-7f261.firebasestorage.app",
  messagingSenderId: "388896933833",
  appId: "1:388896933833:web:5488a824e6b0aaa66b0a18"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);